import { render, staticRenderFns } from "./UpperNote.vue?vue&type=template&id=a7181cc6&scoped=true&"
import script from "./UpperNote.vue?vue&type=script&lang=js&"
export * from "./UpperNote.vue?vue&type=script&lang=js&"
import style0 from "./UpperNote.vue?vue&type=style&index=0&id=a7181cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7181cc6",
  null
  
)

export default component.exports